import { createSlice } from '@reduxjs/toolkit';

import type { TribunalState } from '@/types/tribunal/tribunalTypes';

import {
  buscarTribunaisPorEstado,
  buscarTribunalPorCodigo,
  buscarTribunalPorId,
  listarTribunais,
} from './actions';

const initialState: TribunalState = {
  tribunais: [],
  currentTribunal: null,
  total: 0,
  page: 1,
  limit: 20,
  isLoading: false,
  error: null,
};

const tribunalSlice = createSlice({
  name: 'tribunal',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentTribunal: (state) => {
      state.currentTribunal = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(listarTribunais.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(listarTribunais.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tribunais = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(listarTribunais.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarTribunalPorId.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarTribunalPorId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentTribunal = action.payload;
      })
      .addCase(buscarTribunalPorId.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarTribunalPorCodigo.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarTribunalPorCodigo.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentTribunal = action.payload;
      })
      .addCase(buscarTribunalPorCodigo.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      })

      .addCase(buscarTribunaisPorEstado.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(buscarTribunaisPorEstado.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tribunais = action.payload.data;
        state.total = action.payload.total;
      })
      .addCase(buscarTribunaisPorEstado.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload as string;
      });
  },
});

export default tribunalSlice.reducer;
